import { RadioButton, RadioGroup } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { pitchMarkerColouringModeAtom } from '@/atoms/visualisation';
import { useSetQueryParams } from '@/hooks/queryParams/useSetQueryParams';
import { ConfigDisplaySettingKey } from '@/types/userConfigs';

const COLOURING_OPTIONS = ['default', 'obv', 'none'] as const;

export const PitchMarkerColouring = () => {
  const { t } = useTranslation('visualisation');

  const pitchMarkerColouringMode = useAtomValue(pitchMarkerColouringModeAtom);
  const setQueryParams = useSetQueryParams();

  return (
    <RadioGroup groupId="pitch-marker-colouring" groupTitle={t('markerColouring.title')} size="regular">
      {COLOURING_OPTIONS.map(mode => (
        <RadioButton
          key={mode}
          checked={pitchMarkerColouringMode === mode}
          onChange={() => setQueryParams(ConfigDisplaySettingKey.PITCH_MARKER_COLOURING_MODE, mode)}
          id={`marker-colours-${mode}-option`}
          label={t(`markerColouring.${mode}`)}
          value={mode}
          size="small"
        />
      ))}
    </RadioGroup>
  );
};
